import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ContactUs } from 'src/app/shared/services/contact-us/contact-us';
import { ContactUsService } from 'src/app/shared/services/contact-us/contact-us.service';
import { ErrorComponent, InformationComponent } from 'src/app/shared/util/helpers';
import { TrackerService } from '../../shared/util/tracker.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
    contactItem: ContactUs = new ContactUs();
    isLoading = false;
    contactSuccess = false;

    phoneHref = '';
    emailHref = 'mailto:contact@propero.io';
    dpoHref = 'mailto:dpo@propero.io';
    assistantHref = environment.assistantApp || 'https://admin.propero.io';

    constructor(
        private snackBar: MatSnackBar,
        private translate: TranslateService,
        private trackerService: TrackerService,
        private contactUsService: ContactUsService
    ) { }

    ngOnInit(): void {
        this.trackerService.trackPageView('Contact');
        window.scrollTo(0, 0);

        this.contactItem.subject = '';
        this.contactItem.content = '';
        this.contactItem.email = '';
        this.contactItem.telephone = '';

        const phone = this.translate.instant('COMPANY.CONTACT_MAIN_PHONE') as string;
        this.phoneHref = 'tel:' + phone.replace(/\s/g, '');
        const email = this.translate.instant('COMPANY.CONTACT_MAIN_EMAIL') as string;
        this.emailHref = 'mailto:' + email;
    }

    send(): void {
        if (!this.contactItem.subject?.trim() || !this.contactItem.email?.trim() || !this.contactItem.content?.trim()) {
            this.snackBar.openFromComponent(ErrorComponent, {
                data: { message: this.translate.instant('CONTACT.FORM.REQUIRED') },
                duration: 3000,
            });
            return;
        }

        this.isLoading = true;
        this.contactSuccess = false;
        this.contactItem.date = new Date();

        this.contactUsService.addItem(this.contactItem).subscribe(
            () => {
                this.contactItem.subject = '';
                this.contactItem.email = '';
                this.contactItem.content = '';
                this.contactSuccess = true;
                this.isLoading = false;

                this.snackBar.openFromComponent(InformationComponent, {
                    data: { message: this.translate.instant('CONTACT.FORM.SUCCESS') },
                    duration: 3000,
                });
            },
            () => {
                this.isLoading = false;
                this.snackBar.openFromComponent(ErrorComponent, {
                    data: { message: this.translate.instant('CONTACT.FORM.ERROR') },
                    duration: 3000,
                });
            }
        );
    }
}
